import React, { useState } from "react";
import List from "@material-ui/core/List";
import useDrawerStyles from "./drawerList.styles";
import AccordionMenuComponent from "./accordion-menu.component";

const DrawerListComponent = (props) => {
	const { handleDrawerOpen } = props;
	const app_feature = props.feature;
	const classes = useDrawerStyles();
	const [open, setOpen] = useState("");

	const handleClick = (control) => {
		if (control === open) {
			setOpen("");
		} else {
			setOpen(control);
		}
	};

	const SHOWFEATURE = app_feature.sort((a: any, b: any) => {
		//arrange
		if (a.name < b.name) return -1;
		if (a.name > b.name) return 1;
		return 0;
	});

	return (
		<>
			<List component="nav" className={classes.root} dense={true}>
				{SHOWFEATURE.map((feature, key) => (
					<AccordionMenuComponent
						key={key}
						feature={feature}
						isOpen={open}
						handleDrawerOpen={handleDrawerOpen}
						handleClick={handleClick}
					/>
				))}
			</List>
		</>
	);
};

export default DrawerListComponent;
